import { ACTION } from '@cvent/react-analytics';

export const openSurveyHub = {
  id: 'event_app_open_survey_hub',
  name: 'Open Survey Hub',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics']
};

export const viewPostRegistration = {
  id: 'event_app_view_post_registration',
  name: 'View post-registration',
  type: ACTION,
  destinations: ['Analytics']
};

export const openCustomCards = {
  id: 'open_custom_cards',
  name: 'Open Custom Cards',
  type: ACTION,
  destinations: ['Mixpanel', 'Analytics', 'AttendeeActivities'],
  attributes: [
    'cardType',
    'gallery',
    'single',
    'name',
    'url',
    'cardId',
    'linkType',
    'targetName',
    'targetType',
    'exhibitorId',
    'exhibitorName',
    'featuredExhibitor',
    'sponsoredExhibitor'
  ],
  objectIdAttribute: 'eventId',
  activityType: 'event.customCardOpened'
};
